<template>
  <div>
    <div class="layer-header">
      <h1 class="header-title">개인정보 수집·이용 동의(필수)</h1>
    </div>
    <div class="layer-content">
      <div class="terms_content">
        <h3>마이팩 개인정보 수집·이용 내역(필수)</h3>
        <table>
          <colgroup>
            <col width="33%" />
            <col width="35%" />
            <col width="*" />
          </colgroup>
          <thead>
            <tr>
              <th>수집 항목</th>
              <th>수집 목적</th>
              <th>보유기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>회원 ID, 성명, 성별, 연령대, 휴대폰번호</td>
              <td>
                이용자 식별, 회원 서비스 제공, 고객 고지, 고객 상담, 고객 불만
                처리 접수
              </td>
              <td rowspan="2" class="bold">
                회원 탈퇴시까지 보관. 단, 회사 내부 방침 및 관련 법령에 의해
                보관하여야 할 경우 개인정보처리방침에 게시한 기간에 따라 보유함
              </td>
            </tr>
            <tr>
              <td>회원 ID, 성별, 연령대, 서비스 이용 기록</td>
              <td>개인별 맞춤형 건강기능식품 제공, 통계 작성</td>
            </tr>
            <tr>
              <td>
                성별, 연령대, 서비스 이용기록, 맞춤형 건강기능식품관리사의 상담
                내용
              </td>
              <td>
                맞춤형 건강기능식품 상담, 맞춤형건강기능식품관리사의 직무
                수행내역 등 기록·보관
              </td>
              <td class="bold">
                2년간 또는 건강기능식품법 시행규칙 제16조의 5에서 정한 기간
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          한국암웨이㈜는 회원님의 개인정보를 개인정보보호법, 정보통신망법 기타
          관련 법령에 근거하여 수집·보유 및 처리하고 있습니다. 개인 정보의
          수집·이용에 동의하지 않을 수 있으며, 다만 동의하지 않을 경우 "My Pack
          by Nutrilite" 서비스를 이용할 수 없습니다.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TermPrivacy",
};
</script>
<style scoped>
.terms_box {
  border-top: 0;
}
.bold {
  font-weight: bold;
}
</style>
